module.exports = __webpack_public_path__ + "media/stylesheets/images/userway_logo_images/new-school-91415aa3f6cb6b0219c8aff67c0c7f3b.png";